import React, { FunctionComponent, ReactNode } from 'react'
import styles from './Label.module.sass'
import clsx from 'clsx'

export enum Display {
    TOP = 'display-top',
    LEFT = 'display-left',
    RIGHT = 'display-right',
    CONTENTS = 'display-contents',
}

interface Props {
    className?: string,
    labelClassName?: string,
    contentClassName?: string,
    label?: ReactNode,
    inline?: boolean,
    display?: Display,
    onClick?: () => void,
}

const Label: FunctionComponent<Props> = props => {
    return <div
        className={clsx(
            props.className,
            styles.label,
            styles[props.display || Display.LEFT],
            {
                [styles.clickable]: !!props.onClick,
                [styles.inline]: props.inline
            }
        )}
        onClick={props.onClick}
    >
        <div className={clsx(props.labelClassName, styles.label)}>{props.label}</div>
        <div
            className={clsx(
                props.contentClassName,
                styles.content,
            )}
        >
            {props.children}
        </div>
    </div>
}

export default Label